import {
  FavoriteItemOpenedEvent,
  TelemetryEvents
} from '../../common/telemetryEvents/TelemetryEvents';
import { Telemetry } from '../../commonInfra/services/Telemetry';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { FavoriteItemType } from '../../ts/ServerApi/types/IFavorite';

export function maybeSendTelemetry_favoriteItemOpened(item: IContentInfo<FavoriteItemType>) {
  if (item.favorite) {
    Telemetry.sendEvent<FavoriteItemOpenedEvent>({
      type: TelemetryEvents.FavoriteItemOpened,
      favoriteItemType: item.contentType,
      favoriteItemId: item.id,
    });
  }
}
